/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Запознайте се, общувайте, забавлявайте се",
      "Грешен телефонен номер",
      "Get the app",
      "Продължи с Apple",
      "Продължи с Facebook",
      "Продължи с Google",
      "Вход",
      "Регистрация",
      "За да продължиш, моля въведи символите, които виждаш в полето.",
      "Напред",
      "Въведи символите",
      "Проверка",
      "Обнови",
      "Създай нова парола, която лесно ще запомниш:",
      "Обнови",
      "Потвърди паролата",
      "Паролата трябва да има поне {{num}} [[characters:num]]",
      "Парола",
      "Създай нова парола",
      "Badoo - The Blog",
      "Кариери",
      "Чат",
      "Градове",
      "Управление бисквитки",
      "Авторско право © 2006 – днес. Bumble. Всички права запазени.",
      "Apple и Apple logo са търговски марки на Apple Inc.{{__EOL__}}Google Play е запазена марка на Google LLC.",
      "Изтеглете",
      "Facebook",
      "Следвайте ни",
      "Помощ",
      "Instagram",
      "Език",
      "LinkedIn",
      "Преглед",
      "Badoo е част от Bumble Inc.",
      "Поверителност",
      "Safety Centre",
      "Карта на сайта",
      "Закон за модерното робство",
      "Условия за ползване",
      "Twitter",
      "Въведи имейл или мобилен номер и ще ти изпратим инструкции за създаване на нова парола.",
      "Вземи нова парола",
      "Въведи имейл или телефонен номер",
      "Забравена парола",
      "Снимките са само за илюстрация",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Не чакай взаимна симпатия.{{__EOL__}}{{__EOL__}}Впусни се в дълбоката вода и започни направо с интересното. С разговорите, с които се опознавате.",
      "Чати ли ти се?",
      "Като се регистрираш, приемаш нашите <a class=\"link\" href=\"{{terms_url}}\">Общи условия</a>. Научете как използваме твоите данни в нашата <a class=\"link\" href=\"{{privacy_url}}\">Декларация за поверителност</a>",
      "Подкрепяме това да покажеш истинското си аз <br />и да се чувстваш добре.",
      "За запознанства с увереност.",
      "Или",
      "Вече имаш профил?",
      "Регистрация с имейл или телефонен номер",
      "Вземи това което искаш.{{__EOL__}}Не дължиш извинения.",
      "Просто искаш да чатиш? Няма проблем.{{__EOL__}}Готови за връзка? Страхотно.{{__EOL__}}{{__EOL__}}Ако по-късно промениш целта си, също няма проблем.",
      "Търся срещи",
      "Търся връзка",
      "Искам да чатя",
      "Открий хора, които търсят същото като теб.",
      "{{name}}, {{age}}",
      "Твоята сигурност е наша основна цел.",
      "Нашия Safety Centre е пълен с полезна информация за това как да подхождаш уверено и защитено при запознанства.",
      "Към Safety Centre",
      "Сигурност<br/>по всяко време.",
      "Още от първата секунда знаех, че ще се получи...",
      "В началото не търсех нищо сериозно…",
      "Съветвам всички в Badoo да бъдат себе си, напълно естествени...",
      "Badoo Успешни истории",
      "Виж други истории",
      "{{num}}__CUT__Оценка",
      "Apple App Store",
      "Довери ни се. Събрали сме милиони (и милиони, и милиони) хора заедно от 2006 г. насам.",
      "{{num}}M+__CUT__Изтегляния",
      "{{num}}M+",
      "Google Play Store",
      "Знаем какво правим.",
      "Вход с имейл или телефонен номер",
      "Въведи парола",
      "Забрави паролата си?",
      "Регистрирай се",
      "Нямаш профил?",
      "Вход",
      "Регистрация"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "символа"
            ],
            "singular": [
                  "символ"
            ]
      },
      "day": {
            "plural": [
                  "дни"
            ],
            "singular": [
                  "ден"
            ]
      },
      "hour": {
            "plural": [
                  "часa"
            ],
            "singular": [
                  "час"
            ]
      },
      "minute": {
            "plural": [
                  "минути"
            ],
            "singular": [
                  "минута"
            ]
      },
      "month": {
            "plural": [
                  "месеца"
            ],
            "singular": [
                  "месец"
            ]
      },
      "second": {
            "plural": [
                  "секунди"
            ],
            "singular": [
                  "секунда"
            ]
      },
      "year": {
            "plural": [
                  "години"
            ],
            "singular": [
                  "година"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
